import type { WebSocketClientStatus } from "@js/components/websocket/constants";

export const changeSocketStatus = (status: WebSocketClientStatus) => {
  return {
    type: status,
  };
};
